<template>
  <div>
    <div class="white--text text-center font-weight-bold">
      <div v-if="rtl" style="font-size: 16px;">
        اكبر مؤشرات النمو في شركات الطاقة العالمية
      </div>
      <div v-else style="font-size: 14px;">
        Top Growth Strategies for Global Energy Companies
      </div>
    </div>
    <div class="white--text text-center mb-4">
      <div v-if="rtl" dir="rtl">(كي بي ام جي ٢٠١٩)</div>
      <div v-else>Source: (KPMG, 2019)</div>
    </div>
    <div style="border: 1px solid white; border-radius: 15px;" class="pa-3">
      <v-row no-gutters>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="73"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >73%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto" class="white--text" style="font-size: 17px;">
              <div v-if="rtl" dir="rtl">النمو العضوي</div>
              <div v-else>Organic growth</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="29"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >29%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto" class="text-white" style="font-size: 17px;">
              <div v-if="rtl">
                <div dir="rtl">الابتكار والتكنولوجيا</div>
              </div>
              <div v-else>
                <div>Innovation &</div>
                <div>technological</div>
                <div>transformation</div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="40"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >40%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto" class="white--text" style="font-size: 17px;">
              <div v-if="rtl" dir="rtl">الدمج والاستحواذ</div>
              <div v-else>
                <div>Mergers &</div>
                <div>acquisitions (M&As)</div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="27"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >27%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto" class="white--text" style="font-size: 17px;">
              <div v-if="rtl">
                <div dir="rtl">المشاريع المشتركة والشراكات</div>
              </div>
              <div v-else>
                <div>Joint ventures (JVs)</div>
                <div>& partnerships</div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopGrowthStrategies",
  props: {
    rtl: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style scoped>

</style>